import { AuthError } from './AuthError';

export const contentTypeHeaders = {
  'Content-Type': 'application/json',
};

export const handleResponse = async <T>(response: Response): Promise<T> => {
  const status = response.status;

  if (response.ok) {
    if (status === 204) {
      return response as T;
    }
    const payload = (await response.json()) as T;
    return payload as T;
  } else {
    throw await AuthError.fromResponse(response);
  }
};
